// Curated Unsplash photo IDs for module heroes.
// Using direct image URLs with format+fit params so browsers cache them efficiently.
const U = (id) => `https://images.unsplash.com/${id}?w=1600&q=80&auto=format&fit=crop`;

export const HERO = {
  dashboard: U("photo-1500382017468-9049fed747ef"),    // golden field
  rice: U("photo-1568956953527-9c40e4c19540"),          // rice paddy field
  dairy: U("photo-1550583724-b2692b85b150"),            // milk / dairy
  cattle: U("photo-1500595046743-cd271d694d30"),        // cattle in field
  sheep: U("photo-1484557052118-f32bd25b45b5"),         // sheep flock
  employees: U("photo-1592982537447-6e0aa7d02caa"),     // farmer at work
  stock: U("photo-1553413077-190dd305871c"),            // warehouse / sacks
  cheques: U("photo-1554224155-6726b3ff858f"),          // calculator + papers
  finance: U("photo-1554224155-6726b3ff858f"),          // money / calculator
  reports: U("photo-1551288049-bebda4e38f71"),          // charts / analytics
};

export const HERO_TINT = {
  rice: "green",
  dairy: "teal",
  cattle: "teal",
  sheep: "orange",
  employees: "deep",
  stock: "red",
  cheques: "orange",
  finance: "green",
  reports: "deep",
  dashboard: "green",
};
